import React, { useState } from 'react'
import PropTypes from 'prop-types'

import {
  SliderArrowLeft,
  SliderArrowRight,
  StyledCKEditorContent,
  StyledImageContainer,
  StyledInfos,
  StyledInfosTitle,
  StyledOverlay,
  StyledSlider,
  StyledSliderControls,
  StyledSliderHeader,
  StyledSlides,
  StyledSlidesInfos,
  StyledTitle,
} from './Slider.styled'
import IconButton from '../IconButton/IconButton'
import BulletPointBorder from '../../images/icons/bullet-point-border.svg'

import colors from '../../theme/colors'
import { IconTypeEnum } from '../../theme/icons'
import { HeadingSizeEnum } from '../Heading/Heading'
import pxToRem from '../../utils/pxToRem'
import NormalizeMedia from '../../utils/NormalizeMedia'

const BULLET_POINTS_KEY = 'bulletpoint'

const Slider = (props) => {
  const { className, slides, title } = props

  const [currentSlide, setCurrentSlide] = useState(0)
  const [touchPosition, setTouchPosition] = useState(null)

  const handleTouchStart = (e) => {
    const touchDown = e.touches[0].clientX
    setTouchPosition(touchDown)
  }

  const handleTouchMove = (e) => {
    const touchDown = touchPosition

    if (touchDown === null) {
      return
    }

    const currentTouch = e.touches[0].clientX
    const diff = touchDown - currentTouch

    if (diff > 5) {
      handleActiveCard(currentSlide + 1)
    }

    if (diff < -5) {
      handleActiveCard(currentSlide - 1)
    }

    setTouchPosition(null)
  }

  const handleActiveCard = (position) => {
    if (0 > position || position > slides.length - 1) {
      return
    }
    setCurrentSlide(position)
  }

  const dots =
    slides?.length > 1
      ? slides?.map((slide, index) => (
          <IconButton
            color={currentSlide === index ? colors.unique.black : undefined}
            height={pxToRem(10)}
            key={`${BULLET_POINTS_KEY}-${index}`}
            onClick={() => {
              handleActiveCard(index)
            }}
            type={IconTypeEnum.carrouselArrow}
            width={pxToRem(10)}
          >
            <BulletPointBorder />
          </IconButton>
        ))
      : undefined

  const images = slides.map((slide, index) => (
    <StyledImageContainer
      key={slide.id}
      isActive={currentSlide === index}
      onClick={() => {
        handleActiveCard(index)
      }}
    >
      {NormalizeMedia(slide.image, '', true)}
    </StyledImageContainer>
  ))

  const slidesInfos = slides.map((slide, index) => (
    <StyledInfos key={slide.id} isActive={currentSlide === index}>
      <StyledInfosTitle label={slide.title} size={HeadingSizeEnum.h4} />
      {slide?.text?.content && (
        <StyledCKEditorContent html={slide?.text?.content} />
      )}
    </StyledInfos>
  ))

  return (
    <StyledSlider className={className}>
      <StyledSliderHeader>
        {title && <StyledTitle label={title} size={HeadingSizeEnum.h3} />}
        {slides?.length > 1 && (
          <StyledSliderControls>
            {slides?.length && dots}
            <IconButton
              color={currentSlide !== 0 ? colors.primary.blue : undefined}
              height={pxToRem(24)}
              onClick={() => handleActiveCard(currentSlide - 1)}
              type={IconTypeEnum.carrouselArrow}
              width={pxToRem(24)}
            >
              <SliderArrowLeft />
            </IconButton>
            <IconButton
              color={
                currentSlide !== slides?.length - 1
                  ? colors.primary.blue
                  : undefined
              }
              height={pxToRem(24)}
              onClick={() => handleActiveCard(currentSlide + 1)}
              type={IconTypeEnum.carrouselArrow}
              width={pxToRem(24)}
            >
              <SliderArrowRight />
            </IconButton>
          </StyledSliderControls>
        )}
      </StyledSliderHeader>
      <StyledSlides
        onTouchMove={handleTouchMove}
        onTouchStart={handleTouchStart}
      >
        <StyledOverlay nbOfSlides={slides.length} position={currentSlide}>
          {images}
        </StyledOverlay>
      </StyledSlides>
      <StyledSlidesInfos>{slidesInfos}</StyledSlidesInfos>
    </StyledSlider>
  )
}

Slider.propTypes = {
  className: PropTypes.any,
  slides: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
}

export default Slider
